import { useEffect, useRef, useState } from 'react';
import {
  SearchEngine,
  buildResultList,
  ResultListState,
  ResultList,
  loadQueryActions,
  loadSearchActions,
  loadSearchAnalyticsActions,
  loadAdvancedSearchQueryActions,
} from '@coveo/headless';
import { isEditorActive, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/ban-types
export const useCountTrial = (engine: SearchEngine<{}>, queryParams: any) => {
  const [data, setData] = useState<ResultListState>();
  const resultListRef = useRef<ResultList | null>(null);
  const FIELDS_TO_INCLUDE: string[] = ['trialname'];
  const { executeSearch } = loadSearchActions(engine);
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window === 'undefined' || !queryParams) return;
    const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
    const { updateQuery } = loadQueryActions(engine);
    const searchQueryActionCreators = loadAdvancedSearchQueryActions(engine);
    const trialLocationGovSource =
      process.env.NEXT_PUBLIC_COVEO_CTGOV_LOCATION_SOURCE || 'Trial Location Gov Dev';
    const trialLocationSource =
      process.env.NEXT_PUBLIC_COVEO_CTMS_LOCATION_SOURCE || 'Trial Locations Dev';
    const trialSource = process.env.NEXT_PUBLIC_COVEO_TRIAL_SOURCE || 'Trial Locations Dev';
    const locationQueryValue = ` @trialorgstudyid=[[@trialorgstudyid] @source=("${trialLocationSource}" OR "${trialLocationGovSource}") @documenttype=Location] @trialenrollingstatus="Enrolling"`;

    const advancedSearchQueriesOptions: { aq: string } = {
      aq: `@source=${trialSource}${locationQueryValue}`,
    };

    const searchQueryAction = searchQueryActionCreators.updateAdvancedSearchQueries(
      advancedSearchQueriesOptions
    );
    engine.dispatch(updateQuery({ q: queryParams }));
    engine.dispatch(searchQueryAction);
    const resultList: ResultList = buildResultList(engine, {
      options: {
        fieldsToInclude: FIELDS_TO_INCLUDE,
      },
    });

    resultListRef.current = resultList;

    setData(resultList.state);

    resultList.subscribe(() => {
      setData(resultList.state);
    });

    engine.dispatch(executeSearch(logInterfaceLoad()));
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      resultList.subscribe(() => {});
    };
  }, [queryParams]);

  return { data };
};
